<template>

    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-xl-offset-4">

                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <h3>Recuperar senha</h3>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">                                                               
                            
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>Informe sua nova senha abaixo:</h5>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="input-with-icon-left" title="Pelo menos 8 caracteres" data-tippy-placement="bottom">
                                                    <i class="las la-lock"></i>
                                                    <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senha" name="senha" id="password-register" placeholder="Informe uma senha" required/>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="input-with-icon-left">
                                                    <i class="las la-lock"></i>
                                                    <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senhaConfirmacao" name="senhaConfirmacao" id="password-repeat-register" placeholder="Repita sua senha" required/>
                                                </div>
                                            </div>

                                            <div class="col-lg-12 col-xs-12">
                                                <button class="button full-width margin-top-10 margin-bottom-30" v-bind:class="{'disabled': loading.submit}" type="submit">
                                                    <i class="las la-save"></i>
                                                    <span>Alterar senha</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            

                        </form>

                        
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'RecuperarSenha',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            loading: {
                "submit":           false,
            },
            form: {
                "_cod":             self.$root.user.cod,
                "recuperarSenha":       "",
                "senha":            "",
                "senhaConfirmacao": ""
            }            
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            
            axios.put("api/recuperar-senha.php", self.form)
            .then(response => {
                self.loading.submit = false;
                console.log("ok", response)
                loading.hide();
                alert(response.data.message);
                self.$router.push({ 
                    name:       "Login",
                }).catch(()=>{});              
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": self.form
                };

                axios.get("api/recuperar-senha.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (!response.data.result.cod) {
                        self.$router.push({ 
                            name:       "Login",
                        }).catch(()=>{});                              
                        return false;
                    }
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$router.push({ 
                                name:       "Login",
                            }).catch(()=>{});                                  
                        }
                    }                    
                });   
            });   
        }           
    },    
    created: function() {
        var self = this;
        if (!self.$route.query.c || !self.$route.query.rs) {
            self.$router.push({ 
                name:       "Login",
            }).catch(()=>{});                  
            return false;
        }
        self.form._cod              = self.$route.query.c;        
        self.form.recuperarSenha    = self.$route.query.rs;  
        self.get();      
    },     
    mounted: function() {
        // loading.hide();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .page-recuperarsenha .mmenu-trigger {
        display: none !important;
    }   
    .page-recuperarsenha #wrapper {
        padding-top: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/RecuperarSenha.vue